const errorMessages = {
  required: "required",
  invalidEmail: "invalidEmail",
  invalidPhoneNumber: "invalidPhoneNumber",
  disablePast: "La date ne peut pas être dans le passé",
  pickUpDateAfterAvailabilityDate: "pickUpDateAfterAvailabilityDate",
  DeliveryDeadlineAfterPickUpDate: "DeliveryDeadlineAfterPickUpDate",
  driverMaxExceedsClientPercent: "delivery.form.driver-pricing.errors.max-exceeds-percent",
};

export default errorMessages;
